import { AnyAction, Dispatch } from 'redux';
import { selectAgent } from 'state/Agents/selectors';
import { NotificationAgent } from 'state/Notifications/types';
import { AppDispatch, AppState } from 'state/reducer';
import { fetchWithState } from 'utils/fetch';

import { setAgent, setAgentAvatar } from '.';

export const fetchAgentAvatar =
  (key: string) => async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    const response = (await fetchWithState(dispatch, getState)(
      `agent-avatar?agentKey=${encodeURIComponent(key)}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )) as Response;
    if (response) {
      const avatarUrl = URL.createObjectURL(await response.blob());
      dispatch(setAgentAvatar({ key, avatarUrl }));
    }
  };

export const fetchAgent =
  ({ key, firstName }: NotificationAgent) =>
  async (dispatch: AppDispatch, getState: () => AppState) => {
    const agent = selectAgent(key)(getState());
    !agent && dispatch(setAgent({ key, firstName }));
    !agent?.avatarUrl && dispatch(fetchAgentAvatar(key));
  };
